<template>
  <div class="content conteudo">
    <h1><span><i class="fas fa-book"></i> Conteúdo</span></h1>

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1" v-if="!curso_edicao">Adicionar curso</h2>
        <h2 class="mt-1" v-else>Editar curso</h2>
      </div>
      <div class="col-12 col-md-6 text-center text-md-right">
        <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="redirectToCurso()"><i class="fas fa-chevron-left"></i> Voltar e cancelar</a>
        <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="cadastrar()" v-if="!curso_edicao"><i class="fas fa-check-circle"></i> Salvar </a>
      </div>
    </div>

    <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0">Informações gerais</a>
    <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" v-if="cursoCompleto && cursoCompleto.curso_ementa" @click="redirectToEmenta()">Ementa</a>
    <div class="mt-3 ml-3" v-else-if="curso_edicao"><h3>Carregando...</h3></div><br>
    <curso-info-gerais v-if="(cursoCompleto && cursoCompleto.curso_ementa) || !curso_edicao" ref="cadastrar" :curso_atual="cursoCompleto"
                                        :curso_edicao="curso_edicao"
                                        :curso_edicao_volta="curso_edicao_volta" />

  </div>
</template>

<script>
import CursoInfoGerais from '@/modules/Conteudo/components/CursoInfoGerais'
import CursoAPI from '@/api/curso-api'
import Swal from 'sweetalert2'

export default {
  name: 'AdicionarCursoView',
  components: { CursoInfoGerais },
  props: {
    curso_atual: Object,
    curso_edicao: Boolean,
    curso_edicao_volta: Boolean
  },
  data () {
    return {
      cursoCompleto: {}
    }
  },
  mounted () {
    this.curso_atual &&
    CursoAPI.listarCursoPorId(this.curso_atual.id).then(result => {
      this.cursoCompleto = result
    })
  },
  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    redirectToCurso: function () {
      this.$router.push('/conteudo/curso')
    },

    redirectToEmenta: function () {
      Swal.fire({
        title: 'Você deseja salvar as informações gerais do curso?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }).then((result) => {
        if (result.value) {
          this.$refs.cadastrar.editarCurso()
        } else {
          this.$router.push({ name: 'adicionar-ementa',
            params: {
              curso_id: this.cursoCompleto.id,
              curso_atual: this.cursoCompleto,
              curso_edicao: true,
              curso_edicao_volta_nao: true
            }
          })
        }
      })
    },

    cadastrar: function () {
      this.$refs.cadastrar.cadastrarCurso()
    },

    editar: function () {
      this.$refs.cadastrar.editarCurso()
    }
  }
}
</script>
